import { ArrowUpRight } from "../../../components/svgs";

const AccelerateSection = () => {
  return (
    <section className="bg-primary text-white py-16 md:py-20 px-4" id="request">
      <div className="container mx-auto flex flex-wrap items-center justify-between gap-10">
        <div className="max-w-2xl">
          <p className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
            Build the next capability
          </p>
          <h2 className="text-white font-poppins font-bold tracking-[-0.03em] leading-tight text-3xl md:text-4xl lg:text-5xl mb-5">
            Your workforce strategy deserves a learning system built for the
            work.
          </h2>
          <span className="text-indigo-100 font-poppins text-base md:text-lg leading-relaxed block">
            Tell us what your people need to be able to do. We&apos;ll help
            shape the pathway.
          </span>
        </div>

        <div className="grid gap-3 w-full sm:w-auto min-w-[230px]">
          <a
            href="mailto:business@utiva.io"
            className="bg-secondary text-primary font-poppins font-extrabold rounded-xl flex items-center justify-between gap-4 px-5 py-4 custom-btn"
          >
            Start the conversation <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default AccelerateSection;
